import {
  combineReducers,
} from 'redux'
import * as actionTypes from 'redux/actions/actionTypes'

const defaultSettings = {
  drawerOpen: false,
}

const drawerOpenReducer = (state = defaultSettings.drawerOpen, action) => {
  switch (action.type) {
    case actionTypes.OPEN_MAGIC_DRAWER:
      return true
    case actionTypes.CLOSE_MAGIC_DRAWER:
      return false
    default:
      return state
  }
}

export default combineReducers({
  drawerOpen: drawerOpenReducer,
})



// WEBPACK FOOTER //
// ./src/redux/reducers/uiReducer.js